import { isAxiosError } from 'axios';

export const getErrorMessage = (err: unknown): string => {
  if (typeof err === 'string') {
    return err;
  }

  if (isAxiosError(err)) {
    return `msg: ${err?.message}; code: ${err?.code}; status: ${err?.status}`;
  }

  const e = err as Record<string, any>;
  const error = e.reason || e.error;
  const message = error ? error.toString() : e.message || e.reason || '';
  return message;
};
